@if (smallText) {
  <!-- M1 EMPTY -->
  <img *ngIf="icon" [src]="icon" />
  <div class="text" [class.small]="smallText">{{ displayText }}</div>
  <ng-content></ng-content>
} @else {
  <!-- M8 EMPTY -->
  <img src="assets/images/media/iconography/sample/empty-state.png" [attr.alt]="'empty_state' | translate" loading="lazy" />
  <div class="pubs-empty--title">{{ displayTitle }}</div>
  <div class="pubs-empty--message">{{ displayMessage }}</div>
}
